import React from "react";
import { useNavigate } from "react-router-dom";
import { Boxes, TriangleAlert, Wrench, Tags, ClipboardList, FileText, ArrowRight, Zap } from "lucide-react";

const REPORTS = [
  { to: "/reports/assets", label: "Asset register", desc: "Full inventory with status & PAT — print or PDF", icon: Boxes, color: "#10B981" },
  { to: "/reports/faults", label: "Fault register", desc: "All logged faults with priority & status", icon: TriangleAlert, color: "#EF4444" },
  { to: "/reports/maintenance", label: "Maintenance schedule", desc: "Service jobs with due dates & status", icon: Wrench, color: "#F59E0B" },
  { to: "/reports/pat", label: "PAT / electrical register", desc: "Every asset's tag-test status & next-due date", icon: Zap, color: "#EAB308" },
  { to: "/assets/tags", label: "Asset tags / labels", desc: "Batch print QR labels (Brother / Zebra sizes)", icon: Tags, color: "#8B5CF6" },
  { to: "/surveys", label: "Site survey reports", desc: "Open a survey to print its as-built report", icon: ClipboardList, color: "#3B82F6" },
];

export default function Reports() {
  const nav = useNavigate();
  return (
    <div className="mx-auto max-w-5xl px-4 py-8 sm:px-8">
      <div className="mb-6">
        <span className="font-mono text-xs uppercase tracking-[0.2em] text-primary">Output</span>
        <h1 className="mt-1 text-2xl font-bold tracking-tight sm:text-3xl">Reports</h1>
        <p className="mt-1 text-sm text-muted-foreground">Every printable report and label, in one place.</p>
      </div>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {REPORTS.map((r) => {
          const Icon = r.icon;
          return (
            <button key={r.to} data-testid={`report-link-${r.to.replace(/\//g, "-")}`} onClick={() => nav(r.to)} className="group flex flex-col items-start gap-3 rounded-2xl border border-border bg-card p-5 text-left card-hover">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl" style={{ background: r.color + "1A", color: r.color }}><Icon className="h-5 w-5" /></span>
              <div className="flex-1">
                <h3 className="text-base font-semibold text-foreground">{r.label}</h3>
                <p className="mt-0.5 text-sm text-muted-foreground">{r.desc}</p>
              </div>
              <span className="flex items-center gap-1 text-xs text-primary">Open <ArrowRight className="h-3 w-3 transition-transform group-hover:translate-x-0.5" /></span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
